import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpOperatorOutputFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

/**
 * 
 * @export
 * @interface ExpOperatorOutput
 */

export class ExpOperatorOutputFactory {}
_ExpOperatorOutputFactory = ExpOperatorOutputFactory;
_defineProperty(ExpOperatorOutputFactory, "FromJSON", function (json) {
  return _ExpOperatorOutputFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpOperatorOutputFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'label': json['label'],
    'description': json['description'],
    'valueTypeID': json['valueTypeID'],
    'categoryID': json['categoryID'],
    'multiple': json['multiple'],
    'outputQualifier': json['outputQualifier'],
    'useSourceValueTypeID': json['useSourceValueTypeID']
  };
});
_defineProperty(ExpOperatorOutputFactory, "ToJSON", function (value) {
  return _ExpOperatorOutputFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpOperatorOutputFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'label': value.label,
    'description': value.description,
    'valueTypeID': value.valueTypeID,
    'categoryID': value.categoryID,
    'multiple': value.multiple,
    'outputQualifier': value.outputQualifier,
    'useSourceValueTypeID': value.useSourceValueTypeID
  };
});
//# sourceMappingURL=ExpOperatorOutput.js.map
